module.exports = __webpack_public_path__ + "img/firsticon.d935bb15.svg";